import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { routes } from '#pplx/frontend/apps/ask/routing/spaRoutes.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useSessionStorage } from '#pplx/frontend/browser-storage/hooks/useSessionStorage.js';
import { ENTERPRISE_ONBOARDING_PENDING_KEY } from '#pplx/frontend/components/utils/consts.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useEffect, useRef } from 'react';
export const useEnterprisePostCheckoutSetupTrigger = (onComputerOnboardingV2Handoff) => {
    const { openModal } = useModalContext();
    const router = useRouter();
    const { isEnterprise, isEnterpriseMax } = useIsSubscribed();
    const hasOpenedModalRef = useRef(false);
    const [pendingStep, , getPendingStep] = useSessionStorage(ENTERPRISE_ONBOARDING_PENDING_KEY, null, { broadcast: false });
    useEffect(() => {
        const currentPendingStep = getPendingStep();
        if (hasOpenedModalRef.current ||
            !pendingStep ||
            currentPendingStep !== pendingStep ||
            !isEnterprise) {
            return;
        }
        hasOpenedModalRef.current = true;
        openModal(EnterprisePostCheckoutSetupModalLazy, {
            subscriptionTier: isEnterpriseMax ? 'enterprise-max' : 'enterprise-pro',
            initialStep: pendingStep,
            onComputerOnboardingV2Handoff,
            onPostCheckoutModalClose: () => router.push(routes['/'].href()),
        }, { replace: true });
    }, [
        isEnterprise,
        isEnterpriseMax,
        getPendingStep,
        onComputerOnboardingV2Handoff,
        openModal,
        pendingStep,
        router,
    ]);
};
const EnterprisePostCheckoutSetupModalLazy = Dynamic(async () => {
    const { EnterprisePostCheckoutSetupModal } = await import('#pplx/frontend/apps/ask/billing/components/EnterprisePostCheckoutSetupModal.js');
    return { default: EnterprisePostCheckoutSetupModal };
});
//# sourceMappingURL=useEnterprisePostCheckoutSetupTrigger.js.map